import React, {DetailedHTMLProps, InputHTMLAttributes} from "react";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {UseFormRegister} from "react-hook-form/dist/types/form";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {Path} from "react-hook-form";

export interface InputProps<TFieldValues extends FieldValues> extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
//export interface InputProps<TFieldValues extends FieldValues> extends React.ComponentPropsWithoutRef<"input"> {
    register?: UseFormRegister<TFieldValues>;
    registerOptions?: RegisterOptions;
    errors?: FieldErrors;
    name: Path<TFieldValues>
}

export function Input<T extends FieldValues>(props: InputProps<T>) {
    const {errors, name, register, registerOptions, ...rest} = props;
    const message: string = errors ? (errors[name!] ? errors[name!]?.message : '') as string : '';
    if (!register)
        throw new Error('Non hai specificato <register>!');
    return (
        <>
            <input
                {...rest}
                {...register(name!, registerOptions)}
                className={props.className ? props.className : `appearance-none block w-full px-3 py-2 border 
                                        rounded-md shadow-sm placeholder-gray-400
                                        focus:outline-none
                                        focus:ring-blue-500
                                        focus:border-blue-500 sm:text-sm
                                            ${errors && errors[name!] ? 'border-rose-700' : 'border-gray-300'}`
                }
            />
            {errors && errors[name!] && <p className="text-rose-700">{message}</p>}
        </>
    );
}

export default Input;